import React, { useMemo, useState } from 'react';

import { Check, Close, DoneAll, Search } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox
} from '@material-ui/core/';
import { Autocomplete } from '@material-ui/lab';

import ModalFilterProduct from 'components/Tvendo/Common/ModalFilterArticle';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import { TextField } from '@material-ui/core';
import { currency, onlyInteger, roundMony } from 'hooks/Pipe';

const columns = [
  { field: 'ItemCode', type: 'text', align: 'left', width: 200, header: 'Código' },
  { field: 'ItemName', type: 'text', align: 'left', header: 'Producto' },
  { field: 'unitMsr', type: 'text', align: 'center', width: 100, header: 'Uni. Mj.' },
  { field: 'NumPerMsr', type: 'number', align: 'center', width: 130, header: 'Cant. x Paq.' },
  { field: 'Quantity', align: 'left', width: 130, header: 'Cantidad' },
  { field: 'unit_price', type: 'number', align: 'right', width: 130, header: 'Precio' },
  { field: 'GTotal', type: 'number', align: 'right', width: 100, header: 'Importe' },
  { field: 'actions', type: 'custom', align: 'center', width: 130, header: 'Acciones' }
];

export default WithApp(function DetailsNC(props) {
  const {
    typeNC,
    dataHeader,
    setDataHeader,
    detailsNC,
    setDetailsNC,
    document,
    setDocumentNC,
    importe,
    /* setImporte, */
    showNotify,
    isSaving,
    itemDeletes,
    setItemDeletes,
    handleRemove,
    handleAdd
  } = props;

  const [openModalProduct, setOpenModalProduct] = useState(false); //Abrir modal
  const [productSelect, setProductSelect] = useState({});
  const [products, setProducts] = useState([]);

  async function getProduct(code) {
    let response = await wsFindBy(`base/zone/${dataHeader.base_zone_id}/products`, {
      ItemCode: code
    });
    if (response.success) {
      setProducts(response.data);
    } else {
      showNotify('No se encontró el producto', 'info');
      setProductSelect({});
      setProducts([]);
    }
  }

  const handleChangeProduct = (e) => {
    setProductSelect({ ...productSelect, [e.target.name]: e.target.value });
  };

  function pushArticles(product) {
    let cloneProducts = [...detailsNC];
    if (cloneProducts.some((item) => item.id == product.id)) {
      showNotify('Ya existe este producto', 'info');
      return;
    }
    if (!product.Quantity || product.Quantity < 1) {
      showNotify('Ingrese una cantidad válida', 'info');
      return;
    }

    cloneProducts.unshift({
      ...product,
      unitMsr: product.SalUnitMsr,
      NumPerMsr: product.NumInSale,
      Dscription: product.ItemName
    });
    setDetailsNC([...cloneProducts]);
    calcImport([...cloneProducts]);
    setProductSelect({});
  }

  function deleteRow(key) {
    let cloneProducts = [...detailsNC];
    cloneProducts.splice(
      cloneProducts.findIndex((x) => `${x.SWW}${x.ItemCode}` === key),
      1
    );
    setDetailsNC([...cloneProducts]);

    if ([...cloneProducts].length > 0) {
      calcImport([...cloneProducts]);
    } else {
      if (typeNC === 'NCN') {
        setDocumentNC({ ...document, gross_amount: 0, DocTotal: 0, DiscPrcnt: 0 });
        /* setImporte(0); */
      } else if (typeNC === 'NCL') {
        setDataHeader({ ...dataHeader, gross_amount: 0, DocTotal: 0, DiscPrcnt: 0 });
        /* setImporte(0); */
      }
    }
  }

  const handleChangeRow = (e, ItemCode) => {
    let cloneDetails = [...detailsNC];
    if (ItemCode !== undefined) {
      let objIndex = cloneDetails.findIndex((obj) => `${obj.SWW}${obj.ItemCode}` == ItemCode);
      cloneDetails[objIndex][e.target.name] = parseInt(e.target.value);
    }
    calcImport([...cloneDetails]);
  };

  function calcImport(data) {
    let dataCalc = data.map((item) => {
      item.GTotal = parseFloat(item.Quantity) * parseFloat(item.unit_price) || 0;
      return item;
    });
    setDetailsNC(dataCalc);

    let headerTotal = dataCalc.reduce((a, b) => ({
      GTotal: parseFloat(a.GTotal) + parseFloat(b.GTotal)
    }));

    if (typeNC === 'NCN') {
      setDocumentNC({
        ...document,
        gross_amount: headerTotal.GTotal,
        DocTotal: headerTotal.GTotal
      });
      /* setImporte(headerTotal.GTotal); */
    } else if (typeNC === 'NCL') {
      setDataHeader({
        ...dataHeader,
        gross_amount: headerTotal.GTotal,
        DocTotal:
          headerTotal.GTotal - (parseFloat(dataHeader.DiscPrcnt || 0) * headerTotal.GTotal) / 100
      });
      /* setImporte(headerTotal.GTotal); */
    }
  }

  const [checked, indeterminate] = useMemo(() => {
    if (detailsNC.length === 0) return [false, false];
    if (itemDeletes.length === 0) return [true, false];
    if (detailsNC.length === itemDeletes.length) {
      return [false, false];
    }
    return [false, true];
  }, [detailsNC, itemDeletes]);

  function toogleChecked() {
    if (detailsNC.length === 0) return;
    let newChecked = false;
    if (checked === true) {
      newChecked = false;
    } else if (checked === false && indeterminate === true) {
      newChecked = false;
    } else {
      newChecked = true;
    }
    setItemDeletes(() => {
      if (newChecked === false) {
        return detailsNC.map(obj => obj.LineNum);
      } else {
        return [];
      }
    });
  }

  return (
    <>
      {typeNC === 'NCL' ? (
        <ModalFilterProduct
          open={openModalProduct}
          setOpen={setOpenModalProduct}
          setProductSelect={setProductSelect}
          entity={`base/zone/${dataHeader.base_zone_id}/products`}
          filterCustom={{ base_seller_id: document.base_seller_id }}
        />
      ) : undefined}
      <TableContainer component={Paper}>
        <Table style={{ minWidth: 1300 }} size="small" aria-label="tabla detalle de NC">
          <TableHead>
            <TableRow>
              <TableCell width="50" align="center">
                #
              </TableCell>
              {columns.map((item, i) => {
                return (
                  <TableCell key={i} width={item.width} align={item.align}>
                    {item.header}
                    {item.header === 'Acciones' && (
                      <Checkbox
                        checked={checked}
                        indeterminate={indeterminate}
                        disabled={isSaving}
                        onChange={toogleChecked}
                      />
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {typeNC === 'NCL' ? (
              <TableRow>
                <TableCell>
                  <Button
                    round
                    justIcon
                    simple
                    style={{ cursor: 'pointer', color: '#07c107' }}
                    onClick={() => setOpenModalProduct(true)}
                    disabled={
                      (!dataHeader?.base_business_partner_id && typeNC !== 'NCN') || isSaving
                    }
                  >
                    <Search style={{ width: '27px', height: '27px' }} />
                  </Button>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={products}
                    getOptionLabel={(option) => option.ItemCode}
                    renderInput={(params) => (
                      <TextField {...params} margin="normal" size="small" required />
                    )}
                    onInputChange={(e) => {
                      if (e.target.value?.length > 3) {
                        getProduct(e.target.value);
                      } else {
                        setProductSelect({});
                      }
                    }}
                    disabled={
                      (!dataHeader.base_business_partner_id && typeNC !== 'NCN') || isSaving
                    }
                    noOptionsText="Mínimo 4 caracteres"
                    clearOnEscape={true}
                    clearOnBlur={false}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && products.length === 1) {
                        setProductSelect({ ...products[0], Quantity: 0 });
                        setProducts([]);
                      }
                    }}
                    onChange={(e, item) => {
                      if (!!item) {
                        setProductSelect({ ...item, Quantity: 0 });
                      } else {
                        setProductSelect({});
                        setProducts([]);
                      }
                    }}
                  />
                </TableCell>
                <TableCell>{productSelect.ItemName}</TableCell>
                <TableCell align="center">PZA</TableCell>
                <TableCell align="center">1</TableCell>
                <TableCell>
                  <TextField
                    value={productSelect.Quantity || ''}
                    name="Quantity"
                    onChange={handleChangeProduct}
                    type="number"
                    margin="normal"
                    size="small"
                    inputProps={{ min: 0 }}
                    fullWidth
                    disabled={isSaving}
                  />
                </TableCell>
                <TableCell align="right">{currency(productSelect.unit_price) || '0'}</TableCell>
                <TableCell align="right">
                  {currency(
                    (productSelect.Quantity || 0) * parseFloat(productSelect.unit_price || 0)
                  ) || '0'}
                </TableCell>
                <TableCell align="center">
                  <Button
                    type="submit"
                    justIcon
                    round
                    size="sm"
                    color={props.themeContext.buttonColorSuccess}
                    onClick={() => {
                      if (!!productSelect.id) {
                        pushArticles(productSelect);
                      } else {
                        showNotify('Elija un producto', 'info');
                      }
                    }}
                    disabled={isSaving}
                  >
                    <DoneAll />
                  </Button>
                </TableCell>
              </TableRow>
            ) : undefined}

            {detailsNC.map((obj, i) => {
              return (
                <TableRow
                  key={obj.ItemCode + i}
                  style={{
                    background:
                      obj.SWW === 'B'
                        ? '#00ff7233'
                        : itemDeletes.includes(obj.LineNum)
                        ? '#ffbebe59'
                        : 'none'
                  }}
                >
                  <TableCell align="center">{i + 1}</TableCell>
                  <TableCell>{obj.ItemCode}</TableCell>
                  <TableCell>{obj.Dscription}</TableCell>
                  <TableCell align="center">PZA</TableCell>
                  <TableCell align="center">1</TableCell>
                  <TableCell>
                    <TextField
                      name="Quantity"
                      value={obj.Quantity || ''}
                      type="number"
                      inputProps={{ min: 0 }}
                      fullWidth
                      onChange={(e) => {
                        handleChangeRow(e, `${obj.SWW}${obj.ItemCode}`);
                      }}
                      onKeyPress={onlyInteger}
                      disabled={isSaving || itemDeletes.includes(obj.LineNum)}
                    />
                  </TableCell>
                  <TableCell align="right">{currency(obj.unit_price)}</TableCell>
                  <TableCell align="right">{roundMony(obj.GTotal).toFixed(2)}</TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={!itemDeletes.includes(obj.LineNum)}
                      disabled={isSaving}
                      onChange={() => {
                        if (!itemDeletes.includes(obj.LineNum)) {
                          if (typeNC === 'NCN') {
                            handleRemove(obj.LineNum);
                          } else {
                            deleteRow(`${obj.SWW}${obj.ItemCode}`);
                          }
                        } else {
                          if (isSaving) {
                            return;
                          } else {
                            handleAdd(obj.LineNum);
                          }
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
});
